export interface CommuneData {
  slug: string;
  nom: string;
  codePostal: string;
  urlPath: string;
  communesVoisines: string[];
  estCharleroi: boolean;
}

export const toutesCommunes: CommuneData[] = [
  {
    slug: 'charleroi',
    nom: 'Charleroi',
    codePostal: '6000',
    urlPath: '/fabricant-volet-charleroi/',
    communesVoisines: ['gilly', 'jumet', 'marcinelle'],
    estCharleroi: true,
  },
  {
    slug: 'gilly',
    nom: 'Gilly',
    codePostal: '6060',
    urlPath: '/reparation-volet-gilly/',
    communesVoisines: ['charleroi', 'chatelet', 'couillet'],
    estCharleroi: false,
  },
  {
    slug: 'jumet',
    nom: 'Jumet',
    codePostal: '6040',
    urlPath: '/reparation-volet-jumet/',
    communesVoisines: ['charleroi', 'gosselies', 'ransart'],
    estCharleroi: false,
  },
  {
    slug: 'gosselies',
    nom: 'Gosselies',
    codePostal: '6041',
    urlPath: '/reparation-volet-gosselies/',
    communesVoisines: ['jumet', 'frasnes-lez-gosselies', 'pont-a-celles'],
    estCharleroi: false,
  },
  {
    slug: 'lodelinsart',
    nom: 'Lodelinsart',
    codePostal: '6042',
    urlPath: '/reparation-volet-lodelinsart/',
    communesVoisines: ['charleroi', 'jumet', 'gilly'],
    estCharleroi: false,
  },
  {
    slug: 'couillet',
    nom: 'Couillet',
    codePostal: '6010',
    urlPath: '/reparation-volet-couillet/',
    communesVoisines: ['charleroi', 'gilly', 'chatelet'],
    estCharleroi: false,
  },
  {
    slug: 'marcinelle',
    nom: 'Marcinelle',
    codePostal: '6001',
    urlPath: '/reparation-volet-marcinelle/',
    communesVoisines: ['charleroi', 'couillet', 'montigny-le-tilleul'],
    estCharleroi: false,
  },
  {
    slug: 'marchienne-au-pont',
    nom: 'Marchienne-au-Pont',
    codePostal: '6030',
    urlPath: '/reparation-volet-marchienne-au-pont/',
    communesVoisines: ['charleroi', 'montigny-le-tilleul', 'fontaine-leveque'],
    estCharleroi: false,
  },
  {
    slug: 'ransart',
    nom: 'Ransart',
    codePostal: '6043',
    urlPath: '/reparation-volet-ransart/',
    communesVoisines: ['jumet', 'gosselies', 'fleurus'],
    estCharleroi: false,
  },
  {
    slug: 'dampremy',
    nom: 'Dampremy',
    codePostal: '6020',
    urlPath: '/reparation-volet-dampremy/',
    communesVoisines: ['charleroi', 'jumet', 'lodelinsart'],
    estCharleroi: false,
  },
  {
    slug: 'montigny-le-tilleul',
    nom: 'Montigny-le-Tilleul',
    codePostal: '6110',
    urlPath: '/reparation-volet-montigny-le-tilleul/',
    communesVoisines: ['marchienne-au-pont', 'fontaine-leveque', 'courcelles'],
    estCharleroi: false,
  },
  {
    slug: 'chatelet',
    nom: 'Châtelet',
    codePostal: '6200',
    urlPath: '/reparation-volet-chatelet/',
    communesVoisines: ['gilly', 'couillet', 'chatelineau'],
    estCharleroi: false,
  },
  {
    slug: 'chatelineau',
    nom: 'Châtelineau',
    codePostal: '6200',
    urlPath: '/reparation-volet-chatelineau/',
    communesVoisines: ['chatelet', 'bouffioulx', 'farciennes'],
    estCharleroi: false,
  },
  {
    slug: 'bouffioulx',
    nom: 'Bouffioulx',
    codePostal: '6200',
    urlPath: '/reparation-volet-bouffioulx/',
    communesVoisines: ['chatelineau', 'chatelet', 'farciennes'],
    estCharleroi: false,
  },
  {
    slug: 'farciennes',
    nom: 'Farciennes',
    codePostal: '6240',
    urlPath: '/reparation-volet-farciennes/',
    communesVoisines: ['chatelineau', 'aiseau-presles', 'fleurus'],
    estCharleroi: false,
  },
  {
    slug: 'aiseau-presles',
    nom: 'Aiseau-Presles',
    codePostal: '6250',
    urlPath: '/reparation-volet-aiseau-presles/',
    communesVoisines: ['farciennes', 'chatelet', 'fleurus'],
    estCharleroi: false,
  },
  {
    slug: 'courcelles',
    nom: 'Courcelles',
    codePostal: '6180',
    urlPath: '/reparation-volet-courcelles/',
    communesVoisines: ['fontaine-leveque', 'forchies-la-marche', 'chapelle-lez-herlaimont'],
    estCharleroi: false,
  },
  {
    slug: 'forchies-la-marche',
    nom: 'Forchies-la-Marche',
    codePostal: '6141',
    urlPath: '/reparation-volet-forchies-la-marche/',
    communesVoisines: ['courcelles', 'fontaine-leveque', 'les-bons-villers'],
    estCharleroi: false,
  },
  {
    slug: 'fontaine-leveque',
    nom: 'Fontaine-l\'Évêque',
    codePostal: '6140',
    urlPath: '/reparation-volet-fontaine-leveque/',
    communesVoisines: ['courcelles', 'forchies-la-marche', 'marchienne-au-pont'],
    estCharleroi: false,
  },
  {
    slug: 'fleurus',
    nom: 'Fleurus',
    codePostal: '6220',
    urlPath: '/reparation-volet-fleurus/',
    communesVoisines: ['farciennes', 'lambusart', 'les-bons-villers'],
    estCharleroi: false,
  },
  {
    slug: 'lambusart',
    nom: 'Lambusart',
    codePostal: '6220',
    urlPath: '/reparation-volet-lambusart/',
    communesVoisines: ['fleurus', 'farciennes', 'pont-a-celles'],
    estCharleroi: false,
  },
  {
    slug: 'frasnes-lez-gosselies',
    nom: 'Frasnes-lez-Gosselies',
    codePostal: '6210',
    urlPath: '/reparation-volet-frasnes-lez-gosselies/',
    communesVoisines: ['gosselies', 'les-bons-villers', 'pont-a-celles'],
    estCharleroi: false,
  },
  {
    slug: 'les-bons-villers',
    nom: 'Les Bons Villers',
    codePostal: '6211',
    urlPath: '/reparation-volet-les-bons-villers/',
    communesVoisines: ['frasnes-lez-gosselies', 'liberchies', 'fleurus'],
    estCharleroi: false,
  },
  {
    slug: 'liberchies',
    nom: 'Liberchies',
    codePostal: '6238',
    urlPath: '/reparation-volet-liberchies/',
    communesVoisines: ['les-bons-villers', 'pont-a-celles', 'courcelles'],
    estCharleroi: false,
  },
  {
    slug: 'pont-a-celles',
    nom: 'Pont-à-Celles',
    codePostal: '6230',
    urlPath: '/reparation-volet-pont-a-celles/',
    communesVoisines: ['liberchies', 'gosselies', 'frasnes-lez-gosselies'],
    estCharleroi: false,
  },
  {
    slug: 'gerpinnes',
    nom: 'Gerpinnes',
    codePostal: '6280',
    urlPath: '/reparation-volet-gerpinnes/',
    communesVoisines: ['charleroi', 'marcinelle', 'aiseau-presles'],
    estCharleroi: false,
  },
  {
    slug: 'chapelle-lez-herlaimont',
    nom: 'Chapelle-lez-Herlaimont',
    codePostal: '7160',
    urlPath: '/reparation-volet-chapelle-lez-herlaimont/',
    communesVoisines: ['courcelles', 'fontaine-leveque', 'forchies-la-marche'],
    estCharleroi: false,
  },
];

export function getCommuneBySlug(slug: string): CommuneData | undefined {
  return toutesCommunes.find((c) => c.slug === slug);
}